<div class="loader-wrapper" *ngIf="loaderEnabled$ | async as boolean">
    <div class="backdrop"></div>

    <div class="spinner"></div>
</div>
